"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _dialog = require("@reach/dialog");

require("@reach/dialog/styles.css");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _DialogPopup = _interopRequireDefault(require("./DialogPopup"));

var _model = require("./model");

var _NewTab = _interopRequireDefault(require("./NewTab"));

var _TicketMessage = _interopRequireDefault(require("./TicketMessage"));

var _WatchMessage = _interopRequireDefault(require("./WatchMessage"));

var _SpeakerCard = _interopRequireDefault(require("./SpeakerCard"));

var _calendarProvider = require("../calendar-provider");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  [data-reach-dialog-overlay] {\n    background-color: ", ";\n    transition: background-color 500ms ease;\n    z-index: 10;\n  }\n\n  [data-reach-dialog-content] {\n    background: none;\n    padding: 0;\n  }\n  \n  [data-reach-dialog-overlay] [data-reach-dialog-content] {\n    width: 840px;\n    max-width: 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var eventNames = ['video-room', 'qa-room', 'speaker-room', 'discussion-room', 'any-room', 'link', 'random-room', 'speaker-card', 'watch-livestream', 'talk-calendar', 'quake', 'open-base-modal'];
var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject(), function (_ref) {
  var isOpen = _ref.isOpen;
  return isOpen ? 'hsla(0, 0%, 0%, 0.85)' : 'hsla(0, 0%, 0%, 0.4)';
});

var navigateByLink = function navigateByLink(link, samePage) {
  var a = document.createElement('a');
  a.href = link;

  if (!samePage) {
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
  }

  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

var navToRandom = function navToRandom(content) {
  var links = content.links;

  if (!links) {
    return;
  }

  var len = links.length;
  var ind = Math.floor(Math.random() * len);
  navigateByLink(links[ind]);
};

var navToQuake = function navToQuake(link) {
  var randInd = 1000 + Math.round(Math.random() * 999);
  var defaultNick = "GitNation hero ".concat(randInd);
  var nickName = prompt('Enter you nickname', defaultNick);
  var personalLink = "".concat(link, "&name ").concat(nickName);
  navigateByLink(personalLink);
};

var useBusEvents = function useBusEvents(bus) {
  var _React$useState = _react.default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isOpen = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _React$useState3 = _react.default.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      type = _React$useState4[0],
      setType = _React$useState4[1];

  var _React$useState5 = _react.default.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      content = _React$useState6[0],
      setContent = _React$useState6[1];

  var close = function close() {
    return setOpen(false);
  };

  var getDetails = function getDetails(content) {
    var _bus$getContent = bus.getContent(),
        _bus$getContent$react = _bus$getContent.reactLayerConfig,
        reactLayerConfig = _bus$getContent$react === void 0 ? {} : _bus$getContent$react;

    var status = content ? (0, _model.getEventStatus)(content) : null;
    var isNow = status && status.status === 'now';
    var eventIsAuth = content && content.isAuth;
    var isAuth = eventIsAuth !== null ? eventIsAuth : bus.content.isAuth;
    return {
      status: status && status.status,
      isNow: isNow,
      isAuth: isAuth,
      reactLayerConfig: reactLayerConfig
    };
  };

  var onEvent = function onEvent(_ref2) {
    var type = _ref2.type,
        payload = _ref2.payload;

    if (type === 'click' && eventNames.includes(payload.name)) {
      setType(payload.name);
      setContent(payload);

      var _getDetails = getDetails(payload),
          _status = _getDetails.status,
          _isAuth = _getDetails.isAuth,
          _reactLayerConfig = _getDetails.reactLayerConfig;

      var calendarEventDescription = _reactLayerConfig.calendarEventDescription,
          calendarEventName = _reactLayerConfig.calendarEventName,
          conferenceStart = _reactLayerConfig.conferenceStart,
          conferenceEnd = _reactLayerConfig.conferenceEnd;

      if (payload.name === 'speaker-card') {
        setOpen(true);
        return;
      }

      if (payload.name === 'talk-calendar') {
        var speaker = {
          name: payload.data.speaker,
          activities: {
            talks: [payload.data]
          }
        };
        var link = (0, _calendarProvider.createCalendarLink)(speaker, {
          calendarEventDescription: calendarEventDescription,
          calendarEventName: calendarEventName,
          conferenceStart: conferenceStart,
          conferenceEnd: conferenceEnd
        });
        navigateByLink(link);
        return;
      }
      /* if link is available just click it */


      if ((!_status || _status === 'now') && _isAuth) {
        if (payload.name === 'random-room') {
          navToRandom(payload.data);
          return;
        }

        if (payload.name === 'quake') {
          navToQuake(payload.link);
          return;
        }

        if (payload.link) {
          var samePage = payload.data && payload.data.samePage;
          navigateByLink(payload.link, samePage);
          return;
        }
      } else {
        setOpen(true);
      }
    }
  };

  _react.default.useEffect(function () {
    bus.subscribe(onEvent);

    var unsubscribe = function unsubscribe() {
      /* do nothing as this app is not going to by unmounted */
    };

    return unsubscribe;
  }, []);

  var _getDetails2 = getDetails(content),
      status = _getDetails2.status,
      isAuth = _getDetails2.isAuth,
      isNow = _getDetails2.isNow,
      reactLayerConfig = _getDetails2.reactLayerConfig;

  return {
    isOpen: isOpen,
    type: type,
    close: close,
    content: content,
    status: status,
    isNow: isNow,
    isAuth: isAuth,
    reactLayerConfig: reactLayerConfig
  };
};

var App = function App(_ref3) {
  var bus = _ref3.bus;

  var _useBusEvents = useBusEvents(bus),
      isOpen = _useBusEvents.isOpen,
      close = _useBusEvents.close,
      type = _useBusEvents.type,
      content = _useBusEvents.content,
      status = _useBusEvents.status,
      isAuth = _useBusEvents.isAuth;

  var _bus$getContent2 = bus.getContent(),
      _bus$getContent2$reac = _bus$getContent2.reactLayerConfig,
      reactLayerConfig = _bus$getContent2$reac === void 0 ? {} : _bus$getContent2$reac;

  var ticketsLink = reactLayerConfig.ticketsLink,
      hideSpeakerPopupLabel = reactLayerConfig.hideSpeakerPopupLabel,
      calendarEventDescription = reactLayerConfig.calendarEventDescription,
      calendarEventName = reactLayerConfig.calendarEventName,
      conferenceStart = reactLayerConfig.conferenceStart,
      conferenceEnd = reactLayerConfig.conferenceEnd;

  if (type === 'watch-livestream') {
    return /*#__PURE__*/_react.default.createElement(_dialog.DialogOverlay, {
      isOpen: isOpen,
      onDismiss: close
    }, /*#__PURE__*/_react.default.createElement(GlobalStyle, {
      isOpen: isOpen
    }), /*#__PURE__*/_react.default.createElement(_dialog.DialogContent, {
      "aria-label": "video message from organizers"
    }, isOpen ? /*#__PURE__*/_react.default.createElement(_WatchMessage.default, {
      ticketsLink: ticketsLink
    }) : null));
  }

  if (!content || !isOpen) {
    return null;
  }

  if (type === 'speaker-card') {
    return /*#__PURE__*/_react.default.createElement(_dialog.DialogOverlay, {
      isOpen: isOpen,
      onDismiss: close
    }, /*#__PURE__*/_react.default.createElement(GlobalStyle, {
      isOpen: isOpen
    }), /*#__PURE__*/_react.default.createElement(_dialog.DialogContent, {
      "aria-label": "this activity is not available"
    }, isOpen ? /*#__PURE__*/_react.default.createElement(_SpeakerCard.default, {
      type: type,
      content: content,
      status: status,
      hideLabel: hideSpeakerPopupLabel,
      calendarLinkOptions: {
        calendarEventDescription: calendarEventDescription,
        calendarEventName: calendarEventName,
        conferenceStart: conferenceStart,
        conferenceEnd: conferenceEnd
      }
    }) : null));
  }

  if (!isAuth && status !== 'archived') {
    /* not Auth users always see tickets message */
    return /*#__PURE__*/_react.default.createElement(_dialog.DialogOverlay, {
      isOpen: isOpen,
      onDismiss: close
    }, /*#__PURE__*/_react.default.createElement(GlobalStyle, {
      isOpen: isOpen
    }), /*#__PURE__*/_react.default.createElement(_dialog.DialogContent, {
      "aria-label": "this activity is not available"
    }, isOpen ? /*#__PURE__*/_react.default.createElement(_TicketMessage.default, {
      ticketsLink: ticketsLink
    }) : null));
  }
  /* Auth users if not followed the link will see the popup with explanation */


  return /*#__PURE__*/_react.default.createElement(_dialog.DialogOverlay, {
    isOpen: isOpen,
    onDismiss: close
  }, /*#__PURE__*/_react.default.createElement(GlobalStyle, {
    isOpen: isOpen
  }), /*#__PURE__*/_react.default.createElement(_dialog.DialogContent, {
    "aria-label": "this activity is not available"
  }, isOpen ? /*#__PURE__*/_react.default.createElement(_DialogPopup.default, {
    type: type,
    content: content,
    status: status
  }) : null));
};

var _default = App;
exports.default = _default;